import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconNightVisionOff = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4873_3799)">
        <g clipPath="url(#clip1_4873_3799)">
          <path
            d="M17.5066 17.322C15.8312 17.3216 14.1791 16.9309 12.683 16.1811C11.1869 15.4313 9.88834 14.3433 8.89158 13.0044C7.89481 11.6655 7.22756 10.1131 6.94336 8.4715C6.65915 6.82994 6.7659 5.14501 7.25503 3.55188C5.63144 4.29588 4.22091 5.43194 3.15196 6.85657C2.08301 8.2812 1.38962 9.94909 1.13496 11.7083C0.880298 13.4675 1.07246 15.2621 1.69395 16.9286C2.31544 18.5951 3.34649 20.0805 4.69316 21.2494C6.03984 22.4184 7.65933 23.2338 9.40408 23.6213C11.1488 24.0088 12.9634 23.9561 14.6824 23.4681C16.4015 22.98 17.9703 22.072 19.2461 20.8269C20.5219 19.5818 21.464 18.1139 21.9866 16.4142C20.5828 17.0614 19.054 17.3219 17.5066 17.322Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.6896 10.9497C12.3936 10.9497 11.4336 9.98372 11.4336 8.77772V8.76572C11.4336 7.55972 12.4056 6.58172 13.7016 6.58172C14.9976 6.58172 15.9576 7.54772 15.9576 8.75372V8.76572C15.9576 9.97172 14.9856 10.9497 13.6896 10.9497ZM13.7016 9.89972C14.3376 9.89972 14.7636 9.38372 14.7636 8.77772V8.76572C14.7636 8.15372 14.3316 7.63172 13.6896 7.63172C13.0476 7.63172 12.6216 8.14772 12.6216 8.75372V8.76572C12.6216 9.37172 13.0596 9.89972 13.7016 9.89972ZM16.5159 10.8657V8.53172H16.1379V7.63172H16.5159V7.56572C16.5159 7.19372 16.5999 6.91772 16.7919 6.72572C16.9899 6.52772 17.2539 6.44372 17.6439 6.44372C17.9859 6.44372 18.2079 6.47972 18.3819 6.53372V7.33772C18.2499 7.29572 18.1239 7.27172 17.9559 7.27172C17.7459 7.27172 17.6319 7.36772 17.6319 7.57772V7.65572H18.3819V8.53172H17.6559V10.8657H16.5159ZM18.9399 10.8657V8.53172H18.5619V7.64972H18.9399V7.56572C18.9399 7.19372 19.0239 6.91772 19.2159 6.72572C19.4139 6.52772 19.6779 6.44372 20.0679 6.44372C20.4099 6.44372 20.6319 6.47972 20.8059 6.53372V7.33772C20.6739 7.29572 20.5479 7.27172 20.3799 7.27172C20.1699 7.27172 20.0559 7.36772 20.0559 7.57772V7.65572H20.8059V8.53172H20.0799V10.8657H18.9399Z"
            fill="currentColor"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
